import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/i18n';
import './theme/common.less';
import '@/assets/iconfont/iconfont.css';
import { loadCore } from '@jg/qiankun-micro-tool';
import { message } from 'ant-design-vue';
import report from '@/utils/escalation';
report();
loadCore({
  business: 'Console',
  headerContainer: '#core-header-container',
});
export const prefixCls = 'jant';
message.config({ prefixCls: `${prefixCls}-message` });
createApp(App).use(router).use(i18n).mount('#app');
